import { Component } from '@angular/core';
import { Denuncia } from './interfaces/denuncia';
import { NaturalPerson } from './interfaces/natural-person';
import { JuridicPerson } from './interfaces/juridic-person';
import { Address } from './interfaces/address';
import { SendmailService } from './services/sendmail.service';
import Swal from 'sweetalert2';
import { Additional } from './interfaces/additional';

declare var require: any;
const departament = require('../assets/json/departamentos.json');
const province = require('../assets/json/provincias.json');
const district = require('../assets/json/distritos.json');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'Denuncias Ambientales';
  siteKeyCaptcha = '6Ld3fcUZAAAAAE2OACeu_OiOD9sFWZrQlmAHxjeB';
  date = '';
  entidades = ['Sunat', 'Sunarp'];
  private validatorCaptcha = false;

  denuncia: Denuncia;
  naturalPerson: NaturalPerson;
  juridicPerson: JuridicPerson;
  address: Address;
  naturalPersonD: NaturalPerson;
  juridicPersonD: JuridicPerson;
  addressD: Address;
  addressR: Address;
  additional: Additional;
  additionalD: Additional;

  personD = true;
  personDo = true;
  denunciaP = false;
  respuestP = true;
  vRequired = false;

  departaments: any = departament;
  provinces: any = province;
  district: any = district;

  provincesC: any = province;
  districtC: any = district;

  provincesD: any = province;
  districtD: any = district;

  provincesR: any = province;
  districtR: any = district;

  idDepartament = '11';
  idProvince = '110101';

  idDepartamentD = '11';
  idProvinceD = '110101';

  idDepartamentR = '11';
  idProvinceR = '110101';
  ident = '';

  constructor(private sm: SendmailService) {
    this.reset();
    this.selectDepartament();
    this.selectDepartamentD();
    this.selectDepartamentR();
    this.getDate();
  }

  validator(element: any): boolean {
    if (this.vRequired) {
      if (element === '' || element === undefined) {
        return false;
      }
      return true;
    }
    return true;
  }

  private sendMail(): void {
    this.denuncia.ident = this.ident;
    this.denuncia.juridicPerson = this.juridicPerson;
    this.denuncia.naturalPerson = this.naturalPerson;
    this.denuncia.address = this.address;
    this.denuncia.naturalPersonD = this.naturalPersonD;
    this.denuncia.juridicPersonD = this.juridicPersonD;
    this.denuncia.addressD = this.addressD;
    this.denuncia.addressR = this.addressR;
    this.denuncia.additional = this.additional;
    this.denuncia.additionalD = this.additionalD;
    console.log(this.denuncia);
    this.sm.sendMail(this.denuncia).subscribe((res) => {
      console.log(res);
      if (Swal.isVisible()) {
        // instant regret
        Swal.close();
        Swal.fire(
          '¡Correo Enviado!',
          `Nos pondremos en contacto con usted lo antes posible.</br> Id de Envio: <strong>${this.ident}</strong>`,
          'success'
        ).then(
          () => {
            window.close();
          },
          (dismiss) => {
            console.log(dismiss);
          }
        );
      }
    });
  }

  openSwal(): void {
    if (this.confirm()) {
      this.sendMail();
      Swal.fire('¡Enviando!', 'Enviando correo...', 'warning');
    } else {
      this.vRequired = true;
      Swal.fire(
        'Incorrecto',
        'Debe llenar todos los campos marcados en rojo.',
        'error'
      );
    }
  }

  private confirm(): boolean {
    let np = false;
    let npv = false;
    let jpv = false;
    let npD = false;
    let npvD = false;
    let jpvD = false;
    let dp = false;
    let dpv = false;
    let av = false;
    let avD = false;
    let otros = false;
    if (this.denuncia.typePerson === 'Persona Natural') {
      np = true;
      // solo requerir obligatoriamente solo los campos de persona natural
      if (
        this.naturalPerson.name !== '' ||
        this.naturalPerson.lastnamep !== '' ||
        this.naturalPerson.lastnamem !== '' ||
        this.naturalPerson.name !== undefined ||
        this.naturalPerson.lastnamep !== undefined ||
        this.naturalPerson.lastnamem !== undefined
      ) {
        npv = true;
      }
    } else {
      if (
        this.juridicPerson.razonSocial !== '' ||
        this.juridicPerson.representL !== '' ||
        this.juridicPerson.razonSocial !== undefined ||
        this.juridicPerson.representL !== undefined
      ) {
        jpv = true;
      }
    }

    if (this.denuncia.typePersonD === 'Persona Natural') {
      npD = true;
      // solo requerir obligatoriamente solo los campos de persona natural
      if (
        this.naturalPersonD.name !== '' ||
        this.naturalPersonD.lastnamep !== '' ||
        this.naturalPersonD.lastnamem !== '' ||
        this.naturalPersonD.name !== undefined ||
        this.naturalPersonD.lastnamep !== undefined ||
        this.naturalPersonD.lastnamem !== undefined
      ) {
        npvD = true;
      }
    } else {
      if (
        this.juridicPersonD.razonSocial !== '' ||
        this.juridicPersonD.representL !== '' ||
        this.juridicPersonD.razonSocial !== undefined ||
        this.juridicPersonD.representL !== undefined
      ) {
        jpvD = true;
      }
    }
    if (this.denuncia.deunciaPrev === 'Si') {
      dp = true;
      if (
        this.denuncia.medio !== '' ||
        this.denuncia.fuente !== '' ||
        this.denuncia.medio !== undefined ||
        this.denuncia.fuente !== undefined
      ) {
        dpv = true;
      }
    }
    if (
      this.additional.cel !== 0 ||
      this.additional.postal !== 0 ||
      this.additional.email !== '' ||
      this.additional.cel !== undefined ||
      this.additional.postal !== undefined ||
      this.additional.email !== undefined
    ) {
      av = true;
    }
    if (
      this.additionalD.cel !== 0 ||
      this.additionalD.postal !== 0 ||
      this.additionalD.email !== '' ||
      this.additionalD.cel !== undefined ||
      this.additionalD.postal !== undefined ||
      this.additionalD.email !== undefined
    ) {
      avD = true;
    }
    if (this.denuncia.georeferenceR !== '' || this.denuncia.descriptionH !== ''
    || this.denuncia.georeferenceR !== undefined || this.denuncia.descriptionH !== undefined){
      otros = true;
    }

    if (this.validatorCaptcha) {
      return (
        this.pValidator(np, npv, jpv) &&
        this.pValidator(npD, npvD, jpvD) &&
        this.dpValidator(dp, dpv) &&
        av &&
        avD &&
        otros
      );
    }
    return false;
  }

  pValidator(np: boolean, npv: boolean, jpv: boolean): boolean {
    if (np) {
      if (npv) {
        return true;
      } else {
        return false;
      }
    } else {
      if (jpv) {
        return true;
      } else {
        return false;
      }
    }
  }

  dpValidator(dp: boolean, dpv: boolean): boolean {
    if (dp) {
      if (dpv) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  // falta validar el captcha
  resolved(captchaResponse: string): void {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.validatorCaptcha = true;
  }

  getDate(): void {
    this.ident = Math.random().toString(36).substring(2);
    const date = new Date();
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    this.date = `${date.getDate()} de ${
      months[date.getMonth()]
    }, del ${date.getFullYear()}`;
    this.denuncia.date = this.date;
  }

  reset(): void {
    this.denuncia = {
      date: '',
      descriptionH: '',
      deunciaPrev: 'No',
      respuestS: 'Si',
      identidadR: 'Si',
      typePerson: 'Persona Natural',
      typePersonD: 'Persona Natural',
      entidad: this.entidades[0],
    };

    this.naturalPerson = {
      name: '',
      dni: 0,
      lastnamem: '',
      lastnamep: '',
    };

    this.juridicPerson = {
      razonSocial: '',
      ruc: 0,
    };

    this.address = {
      addressT: '',
      departament: 'Ica',
      province: 'Ica',
      district: 'Ica',
    };

    this.naturalPersonD = {
      name: '',
      dni: 0,
      lastnamem: '',
      lastnamep: '',
    };

    this.juridicPersonD = {
      razonSocial: '',
      ruc: 0,
    };

    this.addressD = {
      addressT: '',
      departament: 'Ica',
      province: 'Ica',
      district: 'Ica',
    };

    this.addressR = {
      addressT: '',
      departament: 'Ica',
      province: 'Ica',
      district: 'Ica',
    };

    this.additional = {
      cel: 0,
      email: '',
      postal: 0,
    };

    this.additionalD = {
      cel: 0,
      email: '',
      postal: 0,
    };
  }

  selectDepartament(): void {
    this.provincesC = this.provinces.filter(
      (data) => data.department_id === this.idDepartament
    );
    this.address.departament = this.departaments.find(
      (element) => element.id === this.idDepartament
    ).name;
    this.selectProvince();
  }

  selectProvince(): void {
    this.districtC = this.district.filter(
      (data2) => data2.province_id === this.idProvince
    );
    const p = this.provinces.find((element) => element.id === this.idProvince);
    if (p !== undefined) {
      this.address.province = p.name;
    }
  }

  selectDepartamentD(): void {
    this.provincesD = this.provinces.filter(
      (data) => data.department_id === this.idDepartamentD
    );
    this.addressD.departament = this.departaments.find(
      (element) => element.id === this.idDepartamentD
    ).name;
    this.selectProvinceD();
  }

  selectProvinceD(): void {
    this.districtD = this.district.filter(
      (data2) => data2.province_id === this.idProvinceD
    );
    const p = this.provinces.find((element) => element.id === this.idProvinceD);
    if (p !== undefined) {
      this.addressD.province = p.name;
    }
  }

  selectDepartamentR(): void {
    this.provincesR = this.provinces.filter(
      (data) => data.department_id === this.idDepartamentR
    );
    this.addressR.departament = this.departaments.find(
      (element) => element.id === this.idDepartamentR
    ).name;
    this.selectProvinceR();
  }

  selectProvinceR(): void {
    this.districtR = this.district.filter(
      (data2) => data2.province_id === this.idProvinceR
    );
    const p = this.provinces.find((element) => element.id === this.idProvinceR);
    if (p !== undefined) {
      this.addressR.province = p.name;
    }
  }
}
